export default {
  common: {
    exception: 'Exception',
    warning: 'Warning'
  },
  inspection: {
    daysRemaining: 'Days Remaining',
    inspectionTableTitle: 'Equipment patrol alarm report',
    companyExpiryTableTitle: 'Enterprise Validity Report'
  },
  alcoholDetectionRecord: {
    licesnePlateNo: 'License plate'
  },
  licensePlate: {
    num: 'License plate'
  },
  devicePermission: {
    '7': 'Site administrator'
  },
  device: {
    upgradeStatus: 'Upgrade status',
    view: 'View',
    newFirmwave: 'New version available'
  },
  devicesCommand: {
    actionId: 'actionId'
  },
  loginLog: {
    ip: 'IP'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/en/v2.js